skrilla.controller('marketPurchaseDetailsCtrl', function ($scope, searchService, $stateParams) {
    searchService.get("markets/purchases/" + $stateParams.id).then(function(response){
        $scope.purchase = response.data;
    });
});